import React from 'react';
import MainConfig from './MainConfig';
import SeriesConfig from '../SeriesConfig';
import LegendControl from '../LegendControl';

export const DEFAULT_CONFIGURATION = {
  chartTitle: '',
  layout: 'pie',
  legendAnchor: null,
  showLabels: true,
  sliceData: 'value',
  seriesLabels: 'outside',
  useDataColor: true,
  scale: 1,
  radius: 73,
  backgroundColor: 'transparent',
  gridColor: 'transparent',
  border_color: 'transparent',
};

function PieChartConfiguration({ meta, horizontalSortType }) {
  return (
    <>
      <MainConfig />
      <LegendControl meta={meta} />
      <SeriesConfig meta={meta} showSort sortType={horizontalSortType} />
    </>
  );
}
export default PieChartConfiguration;
